"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBarTypeEnum = void 0;
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const clsx_1 = __importDefault(require("clsx"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const theme_1 = require("../../styles/theme");
var InfoBarTypeEnum;
(function (InfoBarTypeEnum) {
    InfoBarTypeEnum["WARNING"] = "WARNING";
    InfoBarTypeEnum["ERROR"] = "ERROR";
})(InfoBarTypeEnum = exports.InfoBarTypeEnum || (exports.InfoBarTypeEnum = {}));
const InfoBarCollection = props => {
    const { bars } = props, options = __rest(props, ["bars"]);
    const classes = useInfoBarCollectionStyles(options);
    return (react_1.default.createElement("div", null, bars.map((bar, index) => {
        const background = bar.type === InfoBarTypeEnum.ERROR ? classes.error : classes.warning;
        return (react_1.default.createElement("div", { className: clsx_1.default(classes.backgroundContainer, background), key: index },
            bar.type !== InfoBarTypeEnum.ERROR ? (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: 'fa-circle-exclamation', style: Object.assign(Object.assign({}, styles.icons), { color: theme_1.colors.warningFontColor }) })) : (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: 'fa-circle-xmark', style: Object.assign(Object.assign({}, styles.icons), { color: theme_1.colors.dangerFontColor }) })),
            `${bar.message}`));
    })));
};
const styles = {
    icons: {
        height: 16,
        width: 16,
    },
};
const useInfoBarCollectionStyles = (options) => core_1.makeStyles(theme => ({
    error: {
        backgroundColor: theme_1.colors.colorDanger,
        color: theme_1.colors.dangerFontColor,
    },
    warning: {
        backgroundColor: theme_1.colors.colorWarning,
        color: theme_1.colors.warningFontColor,
    },
    backgroundContainer: {
        padding: '9px 14px 8px 14px',
        minHeight: 35,
        wordBreak: 'break-all',
        gap: 7,
        display: 'flex',
        boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.10)',
        fontFamily: 'Roboto',
        fontSize: 15,
        fontStyle: 'normal',
        fontWeight: 400,
        display: 'flex',
        alignItems: 'center',
    },
}))();
exports.default = InfoBarCollection;
//# sourceMappingURL=InfoBarCollection.js.map